/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { IToysrusFaqData } from './toysrus-faq.data';
import { IToysrusFaqProps } from './toysrus-faq.props.autogenerated';

export interface IToysrusFaqViewProps
  extends IToysrusFaqProps<IToysrusFaqData> {
  faqHtml?: React.ReactNode;
}

/**
 *
 * ToysrusFaq component
 * @extends {React.PureComponent<IToysrusFaqProps<IToysrusFaqData>>}
 */
class ToysrusFaq extends React.PureComponent<
  IToysrusFaqProps<IToysrusFaqData>
> {
  public render(): JSX.Element | null {
    const { pageHeading, pageContent } = this.props.config;

    const htmlContent = (
      <div>
        <div className='row'>
          <div className='col-lg-12 col-md-12 col-sm-12 imgHelpBanner'>
            <a href='#' className='banner-bg-link'>
              <p className='banner-layout-text-small'>{pageHeading}</p>
            </a>
          </div>
        </div>
        <div className='row'>
          <div className='static-page-container'>
            <div className='col-lg-12 col-md-12'>
              <h1 className='about-us-page-heading'>{pageHeading}</h1>
            </div>
            <div className='col-lg-12 col-md-12'>
              <p className='about-us-page-description'>
                {ReactHtmlParser(pageContent)}
              </p>
            </div>
          </div>
        </div>
      </div>
    );

    const ToysrusFaqProps = {
      ...this.props,
      faqHtml: htmlContent,
    };
    return this.props.renderView(ToysrusFaqProps);
  }
}

export default ToysrusFaq;
